class DarnoxTheme {
  constructor() {
    document.documentElement.classList.add('is-ready');
    this.bindMobileMenu();
  }

  bindMobileMenu() {
    const menu = document.querySelector('[data-dx-mobile-menu]');
    if (!menu) return;

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && menu.open) {
        menu.open = false;
        menu.querySelector('summary')?.focus();
      }
    });

    menu.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => {
        menu.open = false;
      });
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new DarnoxTheme(), { once: true });
} else {
  new DarnoxTheme();
}
